import { render, staticRenderFns } from "./modalDeleteTotalSale.vue?vue&type=template&id=703db399"
import script from "./modalDeleteTotalSale.vue?vue&type=script&lang=js"
export * from "./modalDeleteTotalSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports